/* CYPRESTE · CYP ONE — interações da página (JS puro, sem bibliotecas) */
(function () {
  'use strict';
  var doc = document, root = doc.documentElement;
  var mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var reduce = { get matches() { return mqReduce.matches || document.documentElement.classList.contains('cyp-no-motion'); } };
  var CFG = window.cypSettings || {};
  var STR = Object.assign({
    added: 'Produto adicionado ao carrinho',
    viewCart: 'Ver carrinho',
    chooseSize: 'Escolha o seu tamanho para continuar.',
    addError: 'Não foi possível adicionar. Tente novamente.',
    add: 'Adicionar ao carrinho',
    soldOut: 'Esgotado',
    unavailable: 'Indisponível'
  }, window.cypStrings || {});
  var mqMobile = window.matchMedia('(max-width: 767px)');
  var hasIO = 'IntersectionObserver' in window;
  root.classList.add('cyp-js');
  if (!(window.CSS && CSS.supports && CSS.supports('selector(:has(*))')) && document.querySelector('.cyp-hero--overlay')) root.classList.add('cyp-overlay-on');

  function $(sel, ctx) { return (ctx || doc).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }
  function money(cents) {
    var v = (Number(cents) || 0) / 100;
    return 'R$ ' + v.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function bound(el, key) { key = 'cypB' + key; if (!el || el.dataset[key]) return true; el.dataset[key] = '1'; return false; }
  function onReady(fn) { if (doc.readyState !== 'loading') fn(); else doc.addEventListener('DOMContentLoaded', fn); }

  /* ---------- stagger automático em grids de cards ---------- */
  function initStagger() {
    $$('.cyp-cards').forEach(function (grid) {
      var children = $$('.cyp-reveal', grid);
      children.forEach(function (el, i) {
        if (i > 0 && !el.getAttribute('data-reveal-delay')) {
          el.setAttribute('data-reveal-delay', String(Math.min(i * 70, 280)));
        }
      });
    });
  }

  /* ---------- revelar ao rolar ---------- */
  function initReveal(ctx) {
    var els = $$('.cyp-reveal', ctx);
    if (!hasIO || reduce.matches || (window.Shopify && window.Shopify.designMode)) return;
    var vh = window.innerHeight;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.remove('is-pending'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.01 });
    els.forEach(function (el) {
      // o que já está na tela no carregamento fica visível: nada espera animação
      if (el.getBoundingClientRect().top < vh) return;
      var d = el.getAttribute('data-reveal-delay');
      if (d) el.style.transitionDelay = d + 'ms';
      el.classList.add('is-pending');
      io.observe(el);
    });
  }

  /* ---------- 1. barra de anúncio ---------- */
  function initAnnounce() {
    $$('[data-cyp-announce]').forEach(function (bar) {
      if (bound(bar, 'Ann')) return;
      var items = $$('.cyp-announce__item', bar);
      if (items.length < 2) return;
      var i = 0, timer = null, paused = false;
      function show(n) { items.forEach(function (it, k) { it.setAttribute('aria-hidden', k === n ? 'false' : 'true'); }); }
      function tick() { if (paused || !mqMobile.matches || reduce.matches) return; i = (i + 1) % items.length; show(i); }
      show(0);
      timer = setInterval(tick, Number(bar.getAttribute('data-interval')) || 4500);
      bar.addEventListener('mouseenter', function () { paused = true; });
      bar.addEventListener('mouseleave', function () { paused = false; });
      bar.addEventListener('focusin', function () { paused = true; });
      bar.addEventListener('focusout', function () { paused = false; });
    });
  }

  /* ---------- 2. cabeçalho ---------- */
  function initHeader() {
    var header = $('[data-cyp-header]');
    if (!header || bound(header, 'Hdr')) return;
    var ticking = false, wa = $('.cyp-wa'), lastY = window.scrollY, hidden = false;
    var bar = header.closest('.cyp-section-header') || header.parentElement;
    var hideOnScroll = header.getAttribute('data-hide-on-scroll') !== 'false';
    /* cabeçalho transparente: o Hero liga quando é a primeira seção da página */
    var hero = $('[data-cyp-overlay]');
    if (hero && !hero.classList.contains('cyp-hero--overlay')) {
      var main = doc.getElementById('MainContent') || doc.querySelector('main');
      var first = main && Array.prototype.find.call(main.children, function (c) { return c.offsetHeight > 0; });
      if (first && (first === hero || first.contains(hero))) {
        hero.classList.add('cyp-hero--overlay');
        if (!(window.CSS && CSS.supports && CSS.supports('selector(:has(*))'))) root.classList.add('cyp-overlay-on');
      }
    }
    function setHidden(h) { if (h === hidden) return; hidden = h; bar.classList.toggle('is-hidden', h); }
    function update() {
      ticking = false;
      var y = Math.max(0, window.scrollY);
      header.classList.toggle('is-solid', y > 8);
      if (wa) wa.classList.toggle('is-away', mqMobile.matches && y < 320);
      if (hideOnScroll) {
        if (y <= header.offsetHeight || header.classList.contains('is-open')) setHidden(false);
        else if (y > lastY + 6) setHidden(true);
        else if (y < lastY - 6) setHidden(false);
      }
      if (Math.abs(y - lastY) > 6 || y <= header.offsetHeight) lastY = y;
    }
    header.addEventListener('focusin', function () { setHidden(false); });
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();

    function bindToggle(btnSel, panelSel) {
      var btn = $(btnSel, header), panel = $(panelSel, header);
      if (!btn || !panel) return null;
      function set(open) {
        panel.hidden = !open;
        btn.setAttribute('aria-expanded', String(open));
        header.classList.toggle('is-open', open || !!$('[data-cyp-panel-open]', header));
        if (open) { panel.setAttribute('data-cyp-panel-open', ''); var f = $('input, a', panel); if (f) f.focus(); }
        else panel.removeAttribute('data-cyp-panel-open');
      }
      btn.addEventListener('click', function () { set(panel.hidden); });
      doc.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) { set(false); btn.focus(); } });
      return set;
    }
    var setMenu = bindToggle('[data-cyp-menu-toggle]', '[data-cyp-drawer]');
    var setSearch = bindToggle('[data-cyp-search-toggle]', '[data-cyp-search]');
    $$('[data-cyp-drawer] a', header).forEach(function (a) { a.addEventListener('click', function () { if (setMenu) setMenu(false); }); });
  }

  /* ---------- diálogos ---------- */
  var lastOpener = null;
  function openDialog(dlg, opener) {
    if (!dlg) return;
    lastOpener = opener || doc.activeElement;
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
    root.style.overflow = 'hidden';
  }
  function closeDialog(dlg) {
    if (!dlg) return;
    if (typeof dlg.close === 'function' && dlg.open) dlg.close(); else dlg.removeAttribute('open');
  }
  function initDialogs() {
    doc.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-cyp-open]');
      if (opener) {
        e.preventDefault();
        var id = opener.getAttribute('data-cyp-open');
        var dlg = doc.getElementById(id);
        var tpl = opener.getAttribute('data-cyp-template');
        if (dlg && tpl) {
          var t = doc.getElementById(tpl), slot = $('[data-cyp-slot]', dlg);
          if (t && slot) { slot.innerHTML = ''; slot.appendChild(t.content.cloneNode(true)); }
          var titled = $('[data-cyp-dialog-title]', dlg);
          if (titled) dlg.setAttribute('aria-labelledby', titled.id);
          initCounts(dlg);
          highlight(slot);
        }
        if (id.indexOf('cyp-zoom') === 0) fillZoom(dlg);
        openDialog(dlg, opener);
        return;
      }
      var closer = e.target.closest('[data-cyp-close]');
      if (closer) { closeDialog(closer.closest('dialog')); return; }
      if (e.target.tagName === 'DIALOG' && e.target.classList.contains('cyp-dialog')) closeDialog(e.target);
    });
    initDialogsLocal(doc);
  }
  function initDialogsLocal(ctx) {
    $$('dialog.cyp-dialog', ctx).forEach(function (dlg) {
      if (bound(dlg, 'Dlg')) return;
      dlg.addEventListener('close', function () {
        root.style.overflow = '';
        if (lastOpener && lastOpener.focus) lastOpener.focus();
      });
    });
  }
  function fillZoom(dlg) {
    var stage = $('[data-cyp-zoom-stage]', dlg);
    var current = $('.cyp-gallery__slide:not([hidden])');
    if (!stage || !current) return;
    stage.innerHTML = '';
    var clone = current.firstElementChild ? current.firstElementChild.cloneNode(true) : null;
    if (!clone) return;
    var img = clone.tagName === 'IMG' ? clone : $('img', clone);
    if (img) {
      var set = (img.getAttribute('srcset') || '').split(',').map(function (x) { var p = x.trim().split(/\s+/); return { u: p[0], w: parseInt(p[1], 10) || 0 }; }).filter(function (x) { return x.u; });
      if (set.length) { set.sort(function (a, b) { return b.w - a.w; }); img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = set[0].u; }
      img.removeAttribute('loading');
    }
    var scope = current.closest('[data-ring]');
    if (scope) stage.setAttribute('data-ring', scope.getAttribute('data-ring'));
    stage.classList.remove('is-zoomed');
    stage.appendChild(clone);
    initZoomStage(stage);
  }
  /* dentro do zoom: toque/clique aproxima no ponto tocado; arrastar ou mover o mouse passeia pela foto */
  function initZoomStage(stage) {
    if (bound(stage, 'Zoom')) return;
    function origin(e) {
      var r = stage.getBoundingClientRect();
      var x = Math.min(100, Math.max(0, (e.clientX - r.left) / r.width * 100));
      var y = Math.min(100, Math.max(0, (e.clientY - r.top) / r.height * 100));
      var el = stage.firstElementChild; if (el) el.style.transformOrigin = x + '% ' + y + '%';
    }
    var down = null, panned = false;
    stage.addEventListener('pointerdown', function (e) { down = { x: e.clientX, y: e.clientY }; panned = false; if (stage.classList.contains('is-zoomed')) { try { stage.setPointerCapture(e.pointerId); } catch (err) {} } });
    stage.addEventListener('pointermove', function (e) {
      if (!stage.classList.contains('is-zoomed')) return;
      if (e.pointerType === 'mouse' || down) { origin(e); if (down && Math.abs(e.clientX - down.x) + Math.abs(e.clientY - down.y) > 6) panned = true; }
    });
    stage.addEventListener('pointerup', function (e) {
      if (!down) return; down = null;
      if (panned) return;
      if (!stage.classList.contains('is-zoomed')) origin(e);
      stage.classList.toggle('is-zoomed');
    });
    stage.addEventListener('pointercancel', function () { down = null; });
  }

  /* ---------- 4. produto: variantes, galeria, carrinho ---------- */
  var COLOR_MAP = { 'dourado': 'gold', 'ouro': 'gold', 'gold': 'gold', 'prata': 'silver', 'silver': 'silver', 'preto': 'black', 'black': 'black' };
  function colorKey(v) { return COLOR_MAP[String(v || '').trim().toLowerCase()] || ''; }

  function initProduct() {
    var form = $('[data-cyp-form]');
    if (!form || bound(form, 'Form')) return;
    var dataEl = $('[data-cyp-product]');
    var product = dataEl ? JSON.parse(dataEl.textContent) : { variants: [] };
    var idInput = $('input[name="id"]', form);
    var atc = $('[data-cyp-atc]', form);
    var atcLabel = $('[data-cyp-atc-label]', form) || atc;
    var errorEl = $('[data-cyp-error]', form);
    var scope = $('[data-cyp-ring-scope]') || doc.body;
    var gallery = $('[data-cyp-gallery]');
    var colorIndex = Number(form.getAttribute('data-color-index') || 0);
    var sizeIndex = form.getAttribute('data-size-index');
    sizeIndex = sizeIndex === null || sizeIndex === '' ? -1 : Number(sizeIndex);
    var isDemo = form.hasAttribute('data-demo');
    var updateUrl = form.hasAttribute('data-update-url');

    function selected() {
      var opts = [];
      $$('[data-option-index]', form).forEach(function (fs) {
        var idx = Number(fs.getAttribute('data-option-index'));
        var c = $('input:checked', fs);
        opts[idx] = c ? c.value : null;
      });
      return opts;
    }
    function findVariant(opts) {
      return product.variants.filter(function (v) {
        return v.options.every(function (o, i) { return opts[i] === undefined || opts[i] === o; });
      }).find(function (v) { return v.options.every(function (o, i) { return opts[i] === o; }); }) || null;
    }
    function setText(sel, txt) { $$(sel).forEach(function (el) { el.textContent = txt; }); }

    function showSlide(id) {
      if (!gallery) return;
      var slides = $$('.cyp-gallery__slide', gallery), thumbs = $$('.cyp-thumb', gallery);
      var target = slides.find(function (s) { return s.getAttribute('data-media-id') === String(id); });
      if (!target) return;
      slides.forEach(function (s) { s.hidden = s !== target; });
      thumbs.forEach(function (t) { t.setAttribute('aria-current', t.getAttribute('data-target') === String(id) ? 'true' : 'false'); });
      var img = $('img[loading="lazy"]', target); if (img) img.loading = 'eager';
    }
    function filterGallery(colorName) {
      if (!gallery) return;
      var key = colorKey(colorName);
      var thumbs = $$('.cyp-thumb', gallery), slides = $$('.cyp-gallery__slide', gallery);
      var anyTagged = thumbs.some(function (t) { var c = t.getAttribute('data-color'); return c && c !== 'all'; });
      if (!anyTagged) return;
      thumbs.forEach(function (t) {
        var c = t.getAttribute('data-color');
        var same = String(c).trim().toLowerCase() === String(colorName || '').trim().toLowerCase();
        t.hidden = !(c === 'all' || !c || same || (key && colorKey(c) === key));
      });
      var current = slides.find(function (s) { return !s.hidden; });
      var curThumb = current && thumbs.find(function (t) { return t.getAttribute('data-target') === current.getAttribute('data-media-id'); });
      if (!curThumb || curThumb.hidden) {
        var first = thumbs.find(function (t) { return !t.hidden; });
        if (first) showSlide(first.getAttribute('data-target'));
      }
    }

    function refreshAvailability(opts) {
      if (sizeIndex < 0) return;
      var fs = $('[data-option-index="' + sizeIndex + '"]', form);
      if (!fs) return;
      $$('input', fs).forEach(function (inp) {
        var probe = opts.slice(); probe[sizeIndex] = inp.value;
        var v = findVariant(probe);
        inp.disabled = !v || !v.available;
      });
    }

    /* ao escolher a cor, a foto principal vai para a foto dessa cor, mesmo sem tamanho escolhido */
    function jumpToColor(colorName, opts) {
      if (!colorName) return;
      var norm = function (v) { return String(v || '').trim().toLowerCase(); };
      var sameColor = function (v) { return norm(v.options[colorIndex]) === norm(colorName) && v.featured_media_id; };
      var size = sizeIndex >= 0 ? opts[sizeIndex] : null;
      var v = product.variants.find(function (x) { return sameColor(x) && (!size || x.options[sizeIndex] === size); }) || product.variants.find(sameColor);
      if (v) { showSlide(v.featured_media_id); return; }
      if (!gallery) return;
      var key = colorKey(colorName);
      var t = $$('.cyp-thumb', gallery).find(function (x) { var c = x.getAttribute('data-color'); return c && c !== 'all' && (norm(c) === norm(colorName) || (key && colorKey(c) === key)); });
      if (t) showSlide(t.getAttribute('data-target'));
    }
    function update(fromColor) {
      var opts = selected();
      var colorName = opts[colorIndex];
      setText('[data-cyp-color-name]', colorName || '');
      var key = colorKey(colorName);
      if (key) { scope.setAttribute('data-ring', key); $$('[data-cyp-ring-follow]').forEach(function (el) { el.setAttribute('data-ring', key); }); }
      if (fromColor) { filterGallery(colorName); jumpToColor(colorName, opts); }
      refreshAvailability(opts);

      var needSize = sizeIndex >= 0 && !opts[sizeIndex];
      var variant = needSize ? null : findVariant(opts);
      if (!variant && !needSize) {
        idInput.value = '';
        atc.disabled = true; atcLabel.textContent = STR.unavailable;
        return;
      }
      var priceRef = variant || product.variants.find(function (v) { return v.options[colorIndex] === colorName; }) || product.variants[0];
      if (priceRef) {
        var priceEl = doc.querySelector('[data-cyp-price]');
        if (priceEl) { priceEl.classList.add('cyp-price--updating'); setTimeout(function() { priceEl.classList.remove('cyp-price--updating'); }, 420); }
        setText('[data-cyp-price]', money(priceRef.price));
        if (priceRef.compare_at_price && priceRef.compare_at_price > priceRef.price) {
          var save = priceRef.compare_at_price - priceRef.price;
          setText('[data-cyp-compare]', money(priceRef.compare_at_price));
          setText('[data-cyp-save]', money(save));
          setText('[data-cyp-percent]', '−' + Math.round(save * 100 / priceRef.compare_at_price) + '%');
          $$('[data-cyp-discount]').forEach(function (el) { el.hidden = false; });
        } else {
          $$('[data-cyp-discount]').forEach(function (el) { el.hidden = true; });
        }
      }
      if (!variant) { idInput.value = ''; atc.disabled = false; atcLabel.textContent = form.getAttribute('data-label-add') || STR.add; return; }
      idInput.value = variant.id;
      if (variant.available) { atc.disabled = false; atcLabel.textContent = form.getAttribute('data-label-add') || STR.add; }
      else { atc.disabled = true; atcLabel.textContent = form.getAttribute('data-label-soldout') || STR.soldOut; }
      if (errorEl) errorEl.hidden = true;
      if (variant.featured_media_id) showSlide(variant.featured_media_id);
      if (updateUrl && window.history && history.replaceState) {
        var u = new URL(window.location.href); u.searchParams.set('variant', variant.id); history.replaceState({}, '', u.toString());
      }
      setText('[data-cyp-sticky-variant]', [colorName, sizeIndex >= 0 ? opts[sizeIndex] : null].filter(Boolean).join(' · '));
    }

    form.addEventListener('change', function (e) {
      if (!e.target.closest('[data-option-index]')) return;
      var fs = e.target.closest('[data-option-index]');
      update(Number(fs.getAttribute('data-option-index')) === colorIndex);
    });

    if (gallery) {
      gallery.addEventListener('click', function (e) {
        var t = e.target.closest('.cyp-thumb'); if (t) showSlide(t.getAttribute('data-target'));
      });
      initSwipe();
    }

    /* arrastar a foto principal: para a esquerda vai para a próxima, para a direita volta */
    function initSwipe() {
      var stage = $('[data-cyp-swipe]', gallery);
      if (!stage) return;
      function order() {
        var thumbs = $$('.cyp-thumb', gallery).filter(function (t) { return !t.hidden; });
        if (thumbs.length) return thumbs.map(function (t) { return t.getAttribute('data-target'); });
        return $$('.cyp-gallery__slide', gallery).map(function (s) { return s.getAttribute('data-media-id'); });
      }
      function current() { var s = $$('.cyp-gallery__slide', gallery).find(function (x) { return !x.hidden; }); return s; }
      function go(step) {
        var ids = order(); if (ids.length < 2) return false;
        var cur = current(), i = ids.indexOf(cur ? cur.getAttribute('data-media-id') : ids[0]);
        var next = ids[(i + step + ids.length) % ids.length];
        showSlide(next);
        var shown = current();
        if (shown) { shown.classList.remove('is-from-right', 'is-from-left'); void shown.offsetWidth; shown.classList.add(step > 0 ? 'is-from-right' : 'is-from-left'); }
        var th = $('.cyp-thumb[data-target="' + next + '"]', gallery);
        if (th && th.scrollIntoView) th.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
        return true;
      }
      var x0 = 0, y0 = 0, dx = 0, active = false, dragging = false, swipedAt = 0, id = null, slide = null;
      stage.addEventListener('pointerdown', function (e) {
        if (e.button !== 0 || e.target.closest('button, a')) return;
        active = true; dragging = false; dx = 0; x0 = e.clientX; y0 = e.clientY; id = e.pointerId; slide = current();
      });
      stage.addEventListener('pointermove', function (e) {
        if (!active || e.pointerId !== id) return;
        dx = e.clientX - x0; var dy = e.clientY - y0;
        if (!dragging) {
          if (Math.abs(dx) < 8 || Math.abs(dx) < Math.abs(dy)) { if (Math.abs(dy) > 12) active = false; return; }
          dragging = true; stage.classList.add('is-dragging');
          try { stage.setPointerCapture(id); } catch (err) {}
        }
        if (slide) { slide.style.transition = 'none'; slide.style.transform = 'translateX(' + dx * 0.85 + 'px)'; }
      });
      function end() {
        if (!active) return;
        active = false; stage.classList.remove('is-dragging');
        if (slide) { slide.style.transform = ''; slide.style.transition = ''; }
        if (dragging) {
          swipedAt = Date.now();
          if (Math.abs(dx) > Math.min(50, stage.offsetWidth * 0.12)) go(dx < 0 ? 1 : -1);
        }
        dragging = false;
      }
      stage.addEventListener('pointerup', end);
      stage.addEventListener('pointercancel', end);
      stage.addEventListener('lostpointercapture', function (e) { if (e.target === stage) end(); });
      /* logo depois de arrastar, o toque não abre o zoom; tocar na foto (sem arrastar) abre */
      stage.addEventListener('click', function (e) {
        if (Date.now() - swipedAt < 350) { e.preventDefault(); e.stopPropagation(); return; }
        if (!e.target.closest('button, a') && e.target.closest('.cyp-gallery__slide')) {
          var z = $('.cyp-gallery__zoom', gallery); if (z) z.click();
        }
      }, true);
      stage.addEventListener('dragstart', function (e) { e.preventDefault(); });
    }

    // quantidade
    $$('[data-cyp-qty]', form).forEach(function (q) {
      var input = $('input', q);
      q.addEventListener('click', function (e) {
        var b = e.target.closest('button'); if (!b) return;
        var v = Math.max(1, Math.min(10, (parseInt(input.value, 10) || 1) + (b.hasAttribute('data-plus') ? 1 : -1)));
        input.value = v;
      });
    });

    function requireSize() {
      var opts = selected();
      if (sizeIndex >= 0 && !opts[sizeIndex]) {
        var fs = $('[data-option-index="' + sizeIndex + '"]', form);
        if (errorEl) { errorEl.textContent = STR.chooseSize; errorEl.hidden = false; }
        if (fs) { fs.scrollIntoView({ behavior: reduce.matches ? 'auto' : 'smooth', block: 'center' }); var first = $('input:not(:disabled)', fs); if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 350); }
        return false;
      }
      return true;
    }

    form.addEventListener('submit', function (e) {
      if (!requireSize()) { e.preventDefault(); return; }
      if (!window.fetch) return; // envio normal do formulário
      e.preventDefault();
      var qtyInput = $('input[name="quantity"]', form);
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      atc.setAttribute('aria-busy', 'true');
      if (isDemo) {
        setTimeout(function () { atc.removeAttribute('aria-busy'); addCount(qty); toast(STR.added); }, 350);
        return;
      }
      var routes = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(routes + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          atc.removeAttribute('aria-busy');
          if (!res.ok) { if (errorEl) { errorEl.textContent = res.body.description || STR.addError; errorEl.hidden = false; } return; }
          return fetch(routes + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            $$('[data-cyp-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.setAttribute('data-count', cart.item_count); });
            doc.dispatchEvent(new CustomEvent('cyp:cart-added', { detail: { cart: cart } }));
            if (CFG.afterAdd === 'cart') { window.location.href = routes + 'cart'; return; }
            toast(STR.added, routes + 'cart');
          });
        })
        .catch(function () { atc.removeAttribute('aria-busy'); form.submit(); });
    });

    function addCount(n) {
      $$('[data-cyp-cart-count]').forEach(function (el) {
        var c = (parseInt(el.textContent, 10) || 0) + n; el.textContent = c; el.setAttribute('data-count', c);
      });
    }

    // barra fixa no mobile
    var sticky = $('[data-cyp-sticky-buy]');
    if (sticky && hasIO) {
      var atcOut = false, endIn = false;
      function sync() {
        var show = atcOut && !endIn;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
        $$('a, button', sticky).forEach(function (b) { b.tabIndex = show ? 0 : -1; });
        doc.body.classList.toggle('cyp-has-sticky', show);
      }
      new IntersectionObserver(function (en) {
        en.forEach(function (e) { atcOut = !e.isIntersecting && e.boundingClientRect.top < 0; });
        sync();
      }).observe(atc);
      var end = $('[data-cyp-sticky-end]');
      if (end) new IntersectionObserver(function (en) { en.forEach(function (e) { endIn = e.isIntersecting; }); sync(); }).observe(end);
      sync();
      var sbtn = $('[data-cyp-sticky-add]', sticky);
      if (sbtn) sbtn.addEventListener('click', function () {
        if (!requireSize()) return;
        if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true }));
      });
    }

    update(true);
  }

  /* ---------- aviso ---------- */
  var toastTimer = null;
  function toast(msg, link) {
    var t = $('[data-cyp-toast]');
    if (!t) return;
    $('[data-cyp-toast-msg]', t).textContent = msg;
    var a = $('a', t); if (a && link) a.href = link;
    if (a && !a.textContent.trim()) a.textContent = STR.viewCart;
    t.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-visible'); }, 3600);
  }

  /* ---------- contagem animada ---------- */
  function formatNum(n, fmt) {
    if (fmt === 'thousands') return Math.round(n).toLocaleString('pt-BR');
    if (fmt === 'decimal') return n.toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
    return String(Math.round(n));
  }
  function runCount(el) {
    var to = parseFloat(el.getAttribute('data-to'));
    if (isNaN(to)) return;
    var fmt = el.getAttribute('data-format') || 'int';
    if (reduce.matches) { el.textContent = formatNum(to, fmt); return; }
    var dur = 1200, start = null;
    function step(ts) {
      if (start === null) start = ts;
      var p = Math.min(1, (ts - start) / dur), e = 1 - Math.pow(1 - p, 3);
      el.textContent = formatNum(to * e, fmt);
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  function initCounts(ctx) {
    var els = $$('[data-cyp-count]', ctx);
    if (!els.length) return;
    if (!hasIO) { els.forEach(runCount); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { runCount(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.4 });
    els.forEach(function (el) { if (!bound(el, 'Cnt')) io.observe(el); });
  }

  /* ---------- 9. um dia com o CYP ONE ---------- */
  function bars(vals, mark) {
    var max = Math.max.apply(null, vals.concat([1]));
    return '<div class="cyp-bars" aria-hidden="true">' + vals.map(function (h, i) {
      return '<i class="' + (mark(i, h, vals) || '') + '" style="height:' + Math.max(8, Math.round(h * 100 / max)) + '%"></i>';
    }).join('') + '</div>';
  }
  function parseVals(str, fallback) {
    var v = String(str || '').split(/[;,\s]+/).map(Number).filter(function (n) { return !isNaN(n) && n >= 0; });
    return v.length > 1 ? v : fallback;
  }
  var CHARTS = {
    gauge: function (v, custom) { return bars(parseVals(custom, [52, 64, 58, 71, 66, 80, Number(v) || 0]), function (i, h, a) { return i === a.length - 1 ? 'is-gold' : ''; }); },
    steps: function (v, custom) { return bars(parseVals(custom, [10, 18, 34, 80, 46, 22, 30, 64, 28, 12]), function (i, h, a) { return h === Math.max.apply(null, a) ? 'is-gold' : ''; }); },
    stress: function (v, custom) { return bars(parseVals(custom, [20, 24, 30, 26, 40, 58, 86, 92, 70, 44]), function (i, h, a) { return h >= Math.max.apply(null, a) * 0.85 ? 'is-ink' : ''; }); },
    sleep: function () { return '<div class="cyp-hyp" aria-hidden="true">' + [['Acordado', [[2, 4], [61, 3], [96, 4]]], ['REM', [[30, 9], [70, 12]]], ['Leve', [[6, 22], [42, 18], [82, 13]]], ['Profundo', [[14, 14], [52, 9]]]].map(function (r) { return '<div class="cyp-hyp__row"><span>' + r[0] + '</span><span class="cyp-hyp__track">' + r[1].map(function (s) { return '<i style="left:' + s[0] + '%;width:' + s[1] + '%"></i>'; }).join('') + '</span></div>'; }).join('') + '</div>'; }
  };
  function initDay() {
    $$('[data-cyp-day]').forEach(function (sec) {
      if (bound(sec, 'Day')) return;
      var steps = $$('[data-cyp-day-step]', sec), scenes = $$('[data-cyp-scene]', sec);
      var card = $('[data-cyp-day-card]', sec);
      if (!steps.length || !card) return;
      var label = $('[data-day-label]', card), value = $('[data-day-value]', card), unit = $('[data-day-unit]', card), note = $('[data-day-note]', card), chart = $('[data-day-chart]', card), time = $('[data-day-time]', sec);
      var current = -1;
      function activate(i, animate) {
        if (i === current) return; current = i;
        var s = steps[i];
        steps.forEach(function (x, k) { x.classList.toggle('is-active', k === i); });
        scenes.forEach(function (x, k) { x.classList.toggle('is-active', k === i); });
        var wantTop = s.getAttribute('data-card') === 'top';
        if (card.classList.contains('is-top') !== wantTop) {
          if (animate && !reduce.matches) {
            card.classList.add('is-moving');
            setTimeout(function () { card.classList.toggle('is-top', wantTop); card.classList.remove('is-moving'); }, 220);
          } else card.classList.toggle('is-top', wantTop);
        }
        label.textContent = s.getAttribute('data-label') || '';
        unit.textContent = s.getAttribute('data-unit') || '';
        note.textContent = s.getAttribute('data-note') || '';
        if (time) time.textContent = s.getAttribute('data-time') || '';
        var raw = s.getAttribute('data-value') || '';
        var fmt = s.getAttribute('data-format') || 'int';
        var num = parseFloat(raw);
        value.setAttribute('data-format', fmt);
        if (!isNaN(num) && animate) { value.setAttribute('data-to', num); value.textContent = '0'; runCount(value); }
        else value.textContent = isNaN(num) ? raw : formatNum(num, fmt);
        var c = CHARTS[s.getAttribute('data-chart')];
        chart.innerHTML = c ? c(raw, s.getAttribute('data-chart-values')) : '';
      }
      activate(0, false);
      if (!hasIO) return;
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (e) { if (e.isIntersecting) activate(steps.indexOf(e.target), true); });
      }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
      steps.forEach(function (s) { io.observe(s); });
    });
  }

  /* ---------- 10. carrossel do app ---------- */
  function initCarousels() {
    $$('[data-cyp-carousel]').forEach(function (c) {
      if (bound(c, 'Car')) return;
      var track = $('.cyp-carousel__track', c);
      $$('[data-dir]', c).forEach(function (b) {
        b.addEventListener('click', function () {
          var item = $('.cyp-carousel__item', track);
          var w = item ? item.getBoundingClientRect().width + 24 : track.clientWidth * .8;
          track.scrollBy({ left: w * Number(b.getAttribute('data-dir')), behavior: reduce.matches ? 'auto' : 'smooth' });
        });
      });
    });
  }

  /* ---------- 14. FAQ ---------- */
  function initFaq() {
    $$('[data-cyp-faq] .cyp-faq__btn').forEach(function (btn) {
      if (bound(btn, 'Faq')) return;
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
        var panel = doc.getElementById(btn.getAttribute('aria-controls'));
        if (panel) panel.hidden = open;
      });
    });
  }

  /* ---------- vídeo do hero (carrega depois, nunca atrasa a compra) ---------- */
  function initHeroVideo() {
    var v = $('[data-cyp-hero-video]');
    if (!v) return;
    var saveData = navigator.connection && navigator.connection.saveData;
    if (reduce.matches || saveData) return;
    window.addEventListener('load', function () {
      setTimeout(function () {
        var src = v.getAttribute('data-src'); if (!src) return;
        v.src = src; v.hidden = false;
        v.addEventListener('playing', function () { var ph = $('[data-cyp-hero-still]'); if (ph) ph.style.visibility = 'hidden'; }, { once: true });
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      }, 600);
    });
  }

  /* ---------- hero: tilt 3D + parallax por cursor ---------- */
  function initHeroTilt() {
    var hero = $('.cyp-hero');
    if (!hero || reduce.matches) return;
    var stage = $('.cyp-hero__stage', hero) || $('.cyp-hero__visual', hero);
    var copy  = $('.cyp-hero__copy', hero);
    if (!stage) return;
    var mx = 0, my = 0, cx = 0, cy = 0, px = 0, py = 0, raf = null, live = false;
    function lerp(a, b, t) { return a + (b - a) * t; }
    function tick() {
      raf = null;
      cx = lerp(cx, mx, 0.055); cy = lerp(cy, my, 0.055);
      px = lerp(px, -mx * 0.45, 0.055); py = lerp(py, -my * 0.45, 0.055);
      stage.style.transform = 'perspective(900px) rotateX(' + (-cy * 7) + 'deg) rotateY(' + (cx * 9) + 'deg)';
      if (copy) copy.style.transform = 'translate3d(' + (px * 14).toFixed(2) + 'px,' + (py * 8).toFixed(2) + 'px,0)';
      var done = Math.abs(cx - mx) < 0.001 && Math.abs(cy - my) < 0.001 && !live;
      if (!done) raf = requestAnimationFrame(tick);
    }
    hero.addEventListener('mousemove', function (e) {
      var r = hero.getBoundingClientRect();
      mx = (e.clientX - r.left - r.width  / 2) / r.width;
      my = (e.clientY - r.top  - r.height / 2) / r.height;
      live = true; if (!raf) raf = requestAnimationFrame(tick);
    });
    hero.addEventListener('mouseleave', function () {
      mx = 0; my = 0; live = false; if (!raf) raf = requestAnimationFrame(tick);
    });
  }

  /* ---------- paralaxe leve da foto do hero ---------- */
  function initParallax() {
    var els = $$('[data-cyp-parallax]');
    if (!els.length || reduce.matches) return;
    var ticking = false;
    function upd() {
      ticking = false;
      var y = window.scrollY;
      if (y > window.innerHeight * 1.5) return;
      els.forEach(function (el) { el.style.transform = 'translate3d(0,' + (y * 0.1).toFixed(1) + 'px,0)'; });
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(upd); } }, { passive: true });
  }

  /* ---------- destacar marcadores [ASSIM] que faltam preencher ---------- */
  var PH_RE = /\[[^\[\]<>]{1,80}\]/g;
  function highlight(ctx) {
    if (!CFG.highlight || !document.createTreeWalker) return;
    var walker = document.createTreeWalker(ctx || document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        var p = n.parentNode;
        if (!p || /^(SCRIPT|STYLE|TEXTAREA|OPTION|TITLE)$/.test(p.nodeName) || p.closest('.cyp-ph-text')) return NodeFilter.FILTER_REJECT;
        PH_RE.lastIndex = 0;
        return PH_RE.test(n.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      }
    });
    var nodes = []; while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (n) {
      var frag = document.createDocumentFragment(), txt = n.nodeValue, last = 0;
      txt.replace(PH_RE, function (m, idx) {
        frag.appendChild(document.createTextNode(txt.slice(last, idx)));
        var sp = document.createElement('span'); sp.className = 'cyp-ph-text'; sp.textContent = m; frag.appendChild(sp);
        last = idx + m.length; return m;
      });
      frag.appendChild(document.createTextNode(txt.slice(last)));
      n.parentNode.replaceChild(frag, n);
    });
  }

  /* ---------- página do carrinho ---------- */
  function initCart() {
    var form = $('[data-cyp-cart-form]');
    if (!form || bound(form, 'Cart')) return;
    var t = null;
    form.addEventListener('change', function (e) {
      if (!e.target.matches('input[name="updates[]"]')) return;
      clearTimeout(t); t = setTimeout(function () { form.submit(); }, 500);
    });
    $$('[data-cyp-cart-qty]', form).forEach(function (q) {
      var input = $('input', q);
      q.addEventListener('click', function (e) {
        var b = e.target.closest('button'); if (!b) return;
        input.value = Math.max(0, (parseInt(input.value, 10) || 0) + (b.hasAttribute('data-plus') ? 1 : -1));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  /* índice das políticas: aberto no computador, recolhido no celular; marca a cláusula visível */
  function initToc(ctx) {
    var mqWide = window.matchMedia('(min-width: 900px)');
    $$('[data-cyp-toc]', ctx).forEach(function (det) {
      if (bound(det, 'Toc')) return;
      function sync() { det.open = mqWide.matches; }
      sync();
      if (mqWide.addEventListener) mqWide.addEventListener('change', sync);
      det.addEventListener('click', function (e) {
        var a = e.target.closest('a');
        if (a && !mqWide.matches) det.open = false;
        if (!a && mqWide.matches && e.target.closest('summary')) e.preventDefault();
      });
      var links = $$('a[href^="#"]', det);
      if (!('IntersectionObserver' in window) || !links.length) return;
      var map = {};
      links.forEach(function (a) { var t = doc.getElementById(a.getAttribute('href').slice(1)); if (t) map[t.id] = a; });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          links.forEach(function (a) { a.removeAttribute('aria-current'); });
          var a = map[en.target.id]; if (a) a.setAttribute('aria-current', 'true');
        });
      }, { rootMargin: '-20% 0px -70% 0px' });
      Object.keys(map).forEach(function (id) { io.observe(doc.getElementById(id)); });
    });
  }

  onReady(function () {
    highlight(document.body);
    initStagger();
    initReveal();
    initCart();
    initHeroTilt();
    initParallax();
    initAnnounce();
    initHeader();
    initDialogs();
    initProduct();
    initCounts(doc);
    initDay();
    initCarousels();
    initFaq();
    initHeroVideo();
    initToc(doc);
  });

  /* editor do tema: reativa as interações quando uma seção é recarregada */
  document.addEventListener('shopify:section:load', function (e) {
    highlight(e.target);
    initHeader(); initAnnounce(); initDialogsLocal(e.target); initProduct(); initCounts(e.target);
    initDay(); initCarousels(); initFaq(); initCart(); initReveal(e.target); initToc(e.target);
  });
})();
